
(function () {
    "use strict";
  
    function function_image_hover_plp() {
      const style = document.createElement("style");
      style.textContent = `
      
      `;
      document.head.append(style);
      document.querySelectorAll(".product-featured-image").forEach(function (container) {
        let images = Array.from(container.querySelectorAll(".product-secondary-image"));
        let currentImageIndex = 0;
        let lastClickedIndex = 0;
        let isHovering = false;

        function showImage(index) {
            images.forEach((img, i) => {
            
                img.style.display = i === index ? "block" : "none";
            });
        }

        // Hover effect
        container.addEventListener("mouseenter", function () {
            isHovering = true;
            let nextIndex = currentImageIndex + 1 < images.length ? currentImageIndex + 1 : currentImageIndex;
            console.log('nextIndex: ', nextIndex)
            showImage(nextIndex);
        });

        container.addEventListener("mouseleave", function () {
            isHovering = false;
            showImage(lastClickedIndex);
        });

        // Handle next image click
        let nextButton = container.querySelector(".right-arrow");
        if (nextButton) {
            nextButton.addEventListener("click", function (event) {
                event.stopPropagation(); // Prevent interfering with hover events
                if (currentImageIndex + 1 < images.length) {
                    currentImageIndex++;
                }
                lastClickedIndex = currentImageIndex;
                showImage(currentImageIndex);

                if (isHovering) {
                    let hoverIndex = currentImageIndex + 1 < images.length ? currentImageIndex + 1 : currentImageIndex;
                    showImage(hoverIndex);
                }
            });
        }

        // Handle previous image click
        let prevButton = container.querySelector(".left-arrow");
        if (prevButton) {
            prevButton.addEventListener("click", function (event) {
                event.stopPropagation();
                if (currentImageIndex > 0) {
                    currentImageIndex--;
                }
                lastClickedIndex = currentImageIndex;
                showImage(currentImageIndex);

                if (isHovering) {
                    let hoverIndex = currentImageIndex + 1 < images.length ? currentImageIndex + 1 : currentImageIndex;
                    showImage(hoverIndex);
                }
            });
        }

        // Handle swatches
        let swatches = Array.from(container.closest(".product-card").querySelectorAll(".product-card-swatch"));
        swatches.forEach((swatch) => {
            swatch.addEventListener("click", function (event) {
                event.stopPropagation();

                let variantId = swatch.getAttribute("data-variant-id");

                if (variantId) {
                    let matchingImageIndex = images.findIndex(img => {
                        let variantIds = img.getAttribute("data-variant-ids");
                        return variantIds && variantIds.includes(variantId);
                    });

                    if (matchingImageIndex !== -1) {
                        currentImageIndex = matchingImageIndex;
                        lastClickedIndex = matchingImageIndex;
                        showImage(matchingImageIndex);
                    }
                }
            });
        });
    });
     
    }

    function onDOMContentLoaded() {
        const path = location.pathname;
        const isHomePage = path == "/";
        const isProducts = path.includes("/products");
        const isCollections = path.includes("/collections") && !isProducts;
        const isSearchPage = path.includes("/search");
        const isCart = path == "/cart";
        if(isCollections || isHomePage || isSearchPage){
            function_image_hover_plp();
        }
      }
  
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", onDOMContentLoaded, {
        once: true,
      });
    } else {
      onDOMContentLoaded();
    }
  })();